module.exports = __webpack_public_path__ + "img/popup-content-bg.b9868070.jpg";